var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['list-item-circle', _vm.hasIcon && 'has-icon']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }